import * as React from 'react';
import * as styles from './styles.css';
import { ActionLink, Body2, UIHeading5 } from '@cian/ui-kit';

export interface IContentFooterProps {
  title: string;
  subtitle: string;
  actionText: string;
  activeNewbuildingId: number;
  call?: React.ReactNode;
  chat?: React.ReactNode;
}

export const ContentFooter = ({
  title,
  subtitle,
  actionText,
  call,
  chat,
  activeNewbuildingId,
}: IContentFooterProps) => {
  return (
    <div className={styles['container']} key={activeNewbuildingId}>
      <div className={styles['text-wrapper']}>
        <UIHeading5 color="text-secondary-default">{title}</UIHeading5>
        <Body2 color="text-secondary-default">
          {subtitle}{' '}
          <ActionLink color="current_color" inline fontSize="S" textDecoration="underline">
            {actionText}
          </ActionLink>
        </Body2>
      </div>
      <div className={styles['phone-wrapper']}>
        {chat}
        {call}
      </div>
    </div>
  );
};
